import { sendAsyncAction } from '../../core/async.js';

var SteamFriendStatus;
(function (SteamFriendStatus) {
    SteamFriendStatus[SteamFriendStatus["OFFLINE"] = 0] = "OFFLINE";
    SteamFriendStatus[SteamFriendStatus["AWAY"] = 1] = "AWAY";
    SteamFriendStatus[SteamFriendStatus["IN_GAME"] = 2] = "IN_GAME";
    SteamFriendStatus[SteamFriendStatus["ONLINE"] = 3] = "ONLINE";
    SteamFriendStatus[SteamFriendStatus["SLEEP"] = 4] = "SLEEP";
})(SteamFriendStatus || (SteamFriendStatus = {}));
function getFriendsList() {
    return sendAsyncAction({
        actionId: 'getFriendsList',
    });
}

export { SteamFriendStatus, getFriendsList };
//# sourceMappingURL=getFriendsList.js.map
